module.exports = __webpack_public_path__ + "img/logo.5b636e1a.webp";